/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { WorkbookId } from "../../commons/types/WorkbookId";
export const FlagResponse = core.serialization.object({
    id: core.serialization.string(),
    slug: core.serialization.string(),
    label: core.serialization.string(),
    colorHex: core.serialization.string(),
    workbookId: WorkbookId,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
